import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IAppTitle } from '../../../interfaces';
import { IUser } from '../../../interfaces/user.interface';

@Component({
  selector: 'siu-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  @Input() user: IUser;
  @Input() appTitle: IAppTitle;
  @Input() appMenu: any[];
  @Input() drawerOpen: boolean;
  @Input() drawerMini: boolean;
  @Output('on-toogle-drawer') onToogleDrawerEvent: EventEmitter<boolean> = new EventEmitter();
  @Output('on-logout') onLogoutEvent: EventEmitter<any> = new EventEmitter();
  @Input() router: Router;
  @Input() isMobile: boolean = false;
  @Input() showToogleButton: boolean = false;
  @Input() drawerAttached: boolean = false;
  @Output('on-toogle-drawer-attached') onToogleDrawerAttachedEvent: EventEmitter<boolean> = new EventEmitter();
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  @Output('on-change-mobile-size') onChangeMobileSize: EventEmitter<boolean> = new EventEmitter();
  @Output('on-click-logo') onClickLogoEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output('on-click-change-password') onClickChangePasswordEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() showRightSideNav: boolean = true;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');

    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
      this.onChangeMobileSize.emit(this.mobileQuery.matches);
    };

    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.onChangeMobileSize.emit(this.mobileQuery.matches);
    //this.store.uiAction.setIsMobile(this.mobileQuery.matches);
  }

  ngOnDestroy() {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  handleToogleDrawer = () => {
    this.onToogleDrawerEvent.emit(this.drawerOpen ? false : true);
  }

  handleDrawerStateChange = (open) => {
    if (!open) {
      this.onToogleDrawerEvent.emit(false);
    }
  }

  handleClickItemMenu = (e) => {

  }

  handleLogout = () => {
    this.onLogoutEvent.emit();
  }

  handleMouseEnter = () => {
    if (!this.isMobile && !this.drawerAttached) this.onToogleDrawerEvent.emit(true);
  }

  handleMouseLeave = () => {
    if (!this.isMobile && !this.drawerAttached) this.onToogleDrawerEvent.emit(false);
  }

  handleToogleAttachDrawer = () => {
    this.onToogleDrawerAttachedEvent.emit(this.drawerAttached ? false : true);
  }

  handleClickLogo = () => {
    this.onClickLogoEvent.emit();
  }

  handleClickChangePassword = () => {
    this.onClickChangePasswordEvent.emit();
  }

}
